import React from "react";
import AllRoutes from "./Components/AllRoutes/AllRoutes";

function App() {
  return (
    <div>
      <AllRoutes />
    </div>
  );
}

export default App;
